<template>
  <div class="account-right">
    <history-bread-crumb />
    <div class="account-card group-tab">
      <div class="account-header">
        <h4>{{ _T('History') }}</h4>
      </div>
      <div class="account-body history-table no-food">
        <div class="table-responsive" v-if="pastOrders && pastOrders.length">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>{{ _T('Brand name') }}</th>
                <th>{{ _T('Date &amp; Time') }}</th>
                <th>{{ _T('Status') }}</th>
                <th>{{ _T('Action') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(pastOrder, index) in pastOrders"
                :key="pastOrder._id + index"
              >
                <td v-if="brandLogo">
                  <img :src="brandLogo(pastOrder.brand_id, 'goorder_logo')" />
                </td>
                <td>
                  <h6>{{ brandLogo(pastOrder.brand_id, 'name') }}</h6>
                </td>
                <td>{{ orderDate(pastOrder.real_created_datetime) }}</td>
                <td>
                  <span class="history-badge" :class="getOrderBadge(pastOrder)">
                    {{ getOrderStatus(pastOrder) }}
                  </span>
                </td>
                <td>
                  <ul>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="$emit('reOrder', pastOrder)"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.225 10.0739C15.036 10.015 14.8314 10.0332 14.6558 10.1245C14.4802 10.2158 14.3478 10.3729 14.2875 10.5614C13.9332 11.6447 13.2424 12.5868 12.3157 13.2504C11.389 13.9141 10.2747 14.2648 9.135 14.2514C7.72526 14.2674 6.3667 13.7237 5.35723 12.7396C4.34776 11.7554 3.76977 10.4111 3.75 9.00139C3.76977 7.5917 4.34776 6.24737 5.35723 5.26321C6.3667 4.27904 7.72526 3.73536 9.135 3.75139C10.4082 3.74831 11.6422 4.19149 12.6225 5.00389L10.995 4.73389C10.8975 4.71784 10.7977 4.72123 10.7015 4.74386C10.6053 4.7665 10.5145 4.80794 10.4343 4.86579C10.3542 4.92364 10.2862 4.99676 10.2344 5.08096C10.1826 5.16515 10.148 5.25876 10.1325 5.35639C10.1165 5.45393 10.1198 5.55368 10.1425 5.6499C10.1651 5.74612 10.2065 5.83693 10.2644 5.91708C10.3223 5.99724 10.3954 6.06516 10.4796 6.11696C10.5638 6.16875 10.6574 6.20339 10.755 6.21889L13.935 6.74389H14.0625C14.1495 6.74378 14.2358 6.72856 14.3175 6.69889C14.345 6.68846 14.3704 6.67322 14.3925 6.65389C14.4463 6.63389 14.4968 6.60609 14.5425 6.57139L14.61 6.48889C14.61 6.45139 14.6775 6.42139 14.7075 6.37639C14.7375 6.33139 14.7075 6.30139 14.745 6.27139C14.7657 6.22771 14.7833 6.18259 14.7975 6.13639L15.36 3.13639C15.3787 3.03789 15.3778 2.93668 15.3574 2.83853C15.337 2.74037 15.2975 2.6472 15.2411 2.56432C15.1847 2.48144 15.1125 2.41049 15.0287 2.35551C14.9448 2.30053 14.851 2.2626 14.7525 2.24389C14.654 2.22517 14.5528 2.22604 14.4546 2.24644C14.3565 2.26685 14.2633 2.30638 14.1804 2.36279C14.0131 2.47672 13.8978 2.65247 13.86 2.85139L13.6575 3.93889C12.402 2.85082 10.7964 2.25171 9.135 2.25139C7.32745 2.23539 5.58738 2.93711 4.2966 4.20257C3.00583 5.46804 2.26979 7.19387 2.25 9.00139C2.26979 10.8089 3.00583 12.5347 4.2966 13.8002C5.58738 15.0657 7.32745 15.7674 9.135 15.7514C10.5999 15.7739 12.0332 15.3255 13.2241 14.4722C14.415 13.6188 15.3004 12.4057 15.75 11.0114C15.7784 10.9154 15.7874 10.8146 15.7763 10.7151C15.7651 10.6156 15.7342 10.5193 15.6853 10.4319C15.6363 10.3445 15.5704 10.2678 15.4914 10.2063C15.4123 10.1448 15.3217 10.0998 15.225 10.0739Z"
                          ></path>
                        </svg>
                        <span>{{ _T('Reorder') }}</span>
                      </a>
                    </li>
                    <li>
                      <btn-order-details
                        :order-id="pastOrder._id"
                        :store-id="pastOrder.store_id"
                        :brand-id="pastOrder.brand_id"
                        route-name="order-history"
                      />
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h5 class="nothing-found">
            {{ _T('No History found') }}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtnOrderDetails from '@/components/Collections/Order/Buttons/ButtonOrderDetails'
import HistoryBreadCrumb from '@/components/Collections/History/HistoryBreadCrumb'
import { mapGetters } from 'vuex'
export default {
  name: 'DesktopHistory',
  props: {
    pastOrders: {
      type: Array,
      required: true,
    },
    orderBagde: {
      type: Function,
      required: true,
    },
    brandLogo: {
      type: Function,
      required: true,
    },
    orderDate: {
      type: Function,
      required: true,
    },
  },
  components: {
    BtnOrderDetails,
    HistoryBreadCrumb,
  },
  computed: {
    ...mapGetters(['_T']),
  },
  methods: {
    getOrderBadge (order) {
      return this.orderBagde(this.getOrderStatus(order))
    },
    getOrderStatus (order) {
      return order.order_status === this.CONST.ORDER_STATUS_IN_PROGRESS &&
        order.order_system_status === this.CONST.ORDER_SYSTEM_STATUS_REJECTED
        ? 'Cancelled'
        : order.order_status
    },
  },
}
</script>

<style lang="scss" scoped>
.account-right {
  @media (max-width: 575px) {
    display: none;
  }
}
.account-card {
  -webkit-box-shadow: 0px $px4 $px34 rgba($black, 0.07);
  box-shadow: 0px $px4 $px34 rgba($black, 0.07);
  margin: $px18 0 $px30;
  border-radius: $px10;

  .group-tab {
    position: relative;
  }

  .account-header {
    border-bottom: $px1 solid $light-border;
    padding: $px18 $px30 !important;

    h4 {
      font-weight: 600;
      margin-bottom: 0;
    }
  }
}

.history-table {
  padding: $px15 $px30;
  overflow: hidden;
  max-height: $px500;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .nothing-found {
    font-weight: bold;
  }
  table {
    margin-bottom: 0;

    thead {
      th {
        border: none;
        background-color: $light-border;
        font-weight: 600;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: $light-font;
      }
    }

    tbody {
      th,
      td {
        padding: $px14 0;
      }
      tr:first-child {
        td {
          max-width: $px50;
          border-top: none;
        }
      }

      tr {
        td {
          vertical-align: middle;
          letter-spacing: 0.5px;
          border-color: $light-border;

          img {
            width: $px38;
            border-radius: 100%;
          }
          h6 {
            margin-bottom: 0;
            font-weight: 600;
            line-height: $px22;
            letter-spacing: 0.005em;
            width: $px120;
            line-break: anywhere;
          }
        }
      }
    }
  }
  ul {
    li:first-child {
      border-right: $px1 solid $light-border;
      a {
        color: $color-tertiary;
        padding-right: $px10;
        font-weight: 600;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.5px;
      }
    }
    li:last-child {
      a {
        color: $color-primary;
        padding-left: $px10;
        font-weight: 600;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.5px;
      }
    }

    li {
      a {
        svg {
          vertical-align: sub !important;
        }
      }
    }
  }
}

.history-badge {
  padding: $px6;
  font-weight: 600;
  font-size: $px10;
  line-height: $px11;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-radius: $px2;
}

.badge-delivered,
.delivered-title {
  background-color: $color-tertiary-1;
  color: $color-tertiary;
}

.badge-delayed,
.carry-title {
  background-color: $warning-color-background;
  color: $warning-color;
}

.badge-cancle {
  background-color: $color-primary-1;
  color: $color-primary;
}

.badge-process,
.dining-title {
  background-color: $color-secondary-1 !important;
  color: $color-secondary !important;
}

.badge-process,
.dining-title {
  background-color: var(--secondary-color-1);
  color: $color-secondary;
}

h4 {
  font-size: calc(#{$px16} + (18 - 16) * ((100vw - #{$px320}) / (1920 - 320)));
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: $px22;
}

h6 {
  font-size: $px14;
}

ul {
  padding-left: 0;
  margin-bottom: 0;
}

li {
  display: inline-block;
}

@media (max-width: 991px) {
  .account-card .account-header {
    padding: $px20;
  }

  .no-food {
    height: auto;
  }

  .history-table {
    padding: 15px $px20;
  }
}

@media (max-width: 1199px) {
  .account-card .account-header {
    padding: $px20 $px30;
  }

  .history-table {
    table {
      tbody {
        tr {
          td:first-child {
            min-width: $px50;
          }
          td {
            min-width: $px150;
          }

          td:nth-child(3) {
            min-width: $px200;
            padding-left: $px10;
            padding-right: $px10;
          }
        }
      }
    }
  }
}
.history-table {
  ul {
    li {
      a {
        svg {
          vertical-align: sub;
        }

        span {
          font-weight: 600;
          font-size: $px12;
          line-height: $px15;
          letter-spacing: 0.5px;
        }
      }

      &:first-child {
        border-right: $px1 solid $light-border;

        a {
          color: $color-tertiary;
          padding-right: $px10;

          svg {
            path {
              fill: $color-tertiary;
            }
          }
        }
      }

      /deep/ &:last-child {
        border-left: $px1 solid $light-border;

        /deep/ a {
          color: $color-primary;
          padding-left: $px10;

          /deep/ svg {
            path {
              fill: $color-primary !important;
            }
          }
        }
      }
    }
  }
}
</style>
